import { INIT_APP } from 'store/sagas'

export const NAMESPACE = 'KanBo/UserGroups/view/'
export const INIT = NAMESPACE + 'INIT'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const SET_PERMISSION_LEVEL = NAMESPACE + 'SET_PERMISSION_LEVEL'

const initialState = {
  loading: false,
  loaded: false,
  permissionLevel: 0
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT_APP:
    case INIT:
      return {
        ...initialState,
        ...action.payload
      }
    case SET_LOAD_STATUS:
      return {
        ...state,
        loading: action.payload.loading,
        loaded: action.payload.loaded
      }
    case SET_PERMISSION_LEVEL:
      return {
        ...state,
        permissionLevel: action.payload.permissionLevel
      }
    default: return state
  }
}

export function init (payload = initialState) {
  return {
    type: INIT,
    payload
  }
}

export function setLoadStatus ({ loading, loaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      loading,
      loaded
    }
  }
}

export function setPermissionLevel ({ permissionLevel }) {
  return {
    type: SET_PERMISSION_LEVEL,
    payload: {
      permissionLevel
    }
  }
}
